import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

export const bgColors = {
  low: color.AQUAMARINE,
  fair: color.SILVER,
  high: color.WATERMELON,
  default: color.SILVER,
}

export const Tag = styled.div`
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-align: center;
  border-radius: 0.1875rem;
  text-transform: uppercase;
  color: white;
  max-width: 2.8125rem;
  width: 2.8125rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p =>
    bgColors[p?.priceFairness?.toLowerCase()] || bgColors.default};
`
